<mat-card class="mat-card mat-card--widget">
  <div class="row order-upload-table is-fullwidth">
    <table class="is-fullwidth">
      <tr>
        <th>Location</th>
        <th>Account Number</th>
        <th>UPC</th>
        <th>PO Number</th>
        <th>Validation Status</th>
        <th>Description</th>
      </tr>
      <ng-container *ngFor="let order of orderDetails?.data">
        <tr>
          <td>{{ order?.locationId }}</td>
          <td>{{ order?.fdAccountNumber }}</td>
          <td>{{ order?.upc }}</td>
          <td>{{ order?.poNumber }}</td>
          <td
            [ngClass]="{
              'has-error': order.uploadStatus.toLowerCase() == 'failed',
              'has-warning': order.uploadStatus.toLowerCase() === 'warning',
              'has-success': order.uploadStatus.toLowerCase() === 'success'
            }"
          >
            {{ order?.uploadStatus | titlecase }}
          </td>
          <td
            [ngClass]="{
              'has-error': order.uploadStatus.toLowerCase() == 'failed',
              'has-warning': order.uploadStatus.toLowerCase() === 'warning',
              'has-success': order.uploadStatus.toLowerCase() === 'success'
            }"
          >
            {{ order?.uploadMessage }}
          </td>
        </tr>
      </ng-container>
    </table>
  </div>
</mat-card>
